import IconButton from "@mui/material/IconButton";
import UndoIcon from "@mui/icons-material/Undo";
import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import {LibrettoStudioTheme} from "../../utils/utils";

export const SettingsIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M14.8407 6.4713C14.6535 6.03805 14.1376 5.70921 13.6925 5.74042C13.2474 5.77162 12.7327 5.5976 12.5048 5.38038C12.2769 5.16315 12.0921 4.64949 12.1089 4.20184C12.1257 3.75418 11.7814 3.25253 11.3411 3.0773C10.9008 2.90208 10.3057 3.0353 10.0129 3.37014C9.72021 3.70498 9.22952 3.95101 8.91759 3.96061C8.60566 3.97021 8.10897 3.73618 7.80664 3.40974C7.5043 3.08331 6.90324 2.96689 6.47013 3.15411C6.03703 3.34134 5.7059 3.8574 5.73709 4.30265C5.76829 4.7479 5.59432 5.26276 5.37717 5.49079C5.16002 5.71882 4.64653 5.90124 4.20143 5.88683C3.75633 5.87243 3.25244 6.21567 3.07728 6.65613C2.90212 7.09658 3.03529 7.69185 3.37001 7.98468C3.70474 8.27752 3.95069 8.76837 3.96028 9.07921C3.96988 9.39005 3.73713 9.8881 3.40961 10.1905C3.08208 10.493 2.9645 11.093 3.15406 11.5287C3.34362 11.9643 3.85711 12.2932 4.30221 12.262C4.74731 12.2308 5.262 12.4048 5.48995 12.622C5.7179 12.8393 5.90266 13.3505 5.88586 13.7982C5.86906 14.2458 6.21339 14.7475 6.65489 14.9227C7.09639 15.0979 7.69026 14.9647 7.983 14.6299C8.27573 14.295 8.76522 14.049 9.07716 14.0442C9.38909 14.0394 9.88578 14.271 10.1905 14.5975C10.4952 14.9239 11.0951 15.0355 11.5282 14.8483C11.9613 14.6611 12.2924 14.1474 12.2613 13.7022C12.2301 13.2569 12.404 12.742 12.6212 12.514C12.8383 12.286 13.3506 12.1036 13.7981 12.1216C14.2456 12.1396 14.7471 11.7939 14.9223 11.3523C15.0974 10.9106 14.9667 10.3166 14.6295 10.0213C14.2924 9.72609 14.0465 9.24123 14.0381 8.92559C14.0297 8.60995 14.2624 8.1167 14.5911 7.81426C14.755 7.63664 14.8653 7.41636 14.9094 7.17877C14.9536 6.94117 14.9298 6.69594 14.8407 6.4713V6.4713ZM9.92177 11.1447C9.4978 11.328 9.02899 11.3815 8.57466 11.2982C8.12032 11.215 7.70087 10.9988 7.36939 10.677C7.03791 10.3553 6.80928 9.94236 6.71245 9.49058C6.61562 9.0388 6.65492 8.56844 6.82539 8.139C6.99586 7.70957 7.28984 7.34038 7.67013 7.07812C8.05041 6.81587 8.49991 6.67235 8.96176 6.66572C9.42361 6.6591 9.87704 6.78966 10.2647 7.04089C10.6523 7.29212 10.9568 7.65273 11.1395 8.07709C11.3844 8.64501 11.3942 9.28694 11.1666 9.86202C10.9389 10.4371 10.4926 10.8984 9.92537 11.1447H9.92177Z"
                stroke="#1A1A1A" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export const InviteIcon = ({color="white"}) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group">
                <path id="Vector"
                      d="M10.5 10.689V12.2565C9.82119 12.0165 9.09471 11.9429 8.38155 12.0418C7.6684 12.1408 6.9894 12.4094 6.40157 12.8252C5.81375 13.2409 5.33426 13.7916 5.00337 14.4311C4.67249 15.0705 4.49986 15.78 4.5 16.5L3 16.4993C2.99977 15.5834 3.20919 14.6797 3.61222 13.8573C4.01526 13.0349 4.6012 12.3157 5.32516 11.7548C6.04912 11.1939 6.89188 10.8061 7.78887 10.6212C8.68585 10.4364 9.61325 10.4593 10.5 10.6883V10.689ZM9 9.75C6.51375 9.75 4.5 7.73625 4.5 5.25C4.5 2.76375 6.51375 0.75 9 0.75C11.4862 0.75 13.5 2.76375 13.5 5.25C13.5 7.73625 11.4862 9.75 9 9.75ZM9 8.25C10.6575 8.25 12 6.9075 12 5.25C12 3.5925 10.6575 2.25 9 2.25C7.3425 2.25 6 3.5925 6 5.25C6 6.9075 7.3425 8.25 9 8.25ZM13.5 12.75V10.5H15V12.75H17.25V14.25H15V16.5H13.5V14.25H11.25V12.75H13.5Z"
                      fill={color}/>
            </g>
        </svg>
    )
}

export const StudioBackIcon = ({color}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M14 7L9 12L14 17" stroke={color} strokeWidth="1.5" strokeLinecap="square"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export const CheckmarkIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 8.375L9.75 16.625L6 12.875" stroke="#2B6BFD" strokeWidth="1.5" strokeLinecap="square"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export const StudioBackIconButton = ({handleClick, disabled, theme}) => {

    const color = theme === LibrettoStudioTheme.Light ? "#1a1a1a" : "#ffffff";

    return (
        <Tooltip title="Back">
            <IconButton onClick={handleClick} disabled={disabled} sx={{
                color: color,
            fontSize: '1rem', // Increase the font size
            // You can also adjust the size of the icon itself
            '& .MuiSvgIcon-root': { fontSize: '1rem' }
        }}>
            <StudioBackIcon color={color}/>
        </IconButton>
    </Tooltip>
    )
}

export const DropdownArrowIcon = ({isPrejoin, isDisabled}) => {

    const fillColor = isPrejoin ? "#ffffff" : isDisabled ? "#666666" : "#1A1A1A";

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path d="M8.5 10.5L12.5 14.5L16.5 10.5" fill={fillColor}/>
            <path d="M8.5 10.5L12.5 14.5L16.5 10.5H8.5Z" stroke={fillColor} stroke-linecap="round"
                  stroke-linejoin="round"/>
        </svg>
    )
}
